import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FlyerType } from '../FlyerTypePicker';

export type LayoutType = 'PortraitFlyer' | 'LandscapeFlyer' | 'Circular';


const useLayout = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const params = useParams();
  const { flyerType } = params;
  const [layout, setLayout] = useState<LayoutType>('PortraitFlyer');


  useEffect(() => {
    // TODO extendable check
    const isLandscapeFlyerType = flyerType === 'green' || flyerType === 'brochure'
    const isCircularFlyerType = (flyerType === FlyerType.STAR_STICKER || flyerType === FlyerType.EURO_STICKER)

    if (isLandscapeFlyerType) {
      setLayout('LandscapeFlyer');
    } else if (isCircularFlyerType) {
      setLayout('Circular');
    } else {
      setLayout('PortraitFlyer');
    }

    // Define the media query
    const mediaQuery = window.matchMedia(`(max-width: ${isLandscapeFlyerType ? 1150 : 950 }px)`);

    // Function to handle changes to the media query
    const handleMediaChange = (event) => {
      setIsSmallScreen(event.matches);
    };

    // Initial check
    handleMediaChange(mediaQuery);

    // Add an event listener to handle changes to the media query
    mediaQuery.addEventListener("change", handleMediaChange);

    // Cleanup the event listener on component unmount
    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange)
    };

  }, [flyerType]);

  return { isSmallScreen, layout };
};

export default useLayout;